/* wgw-logo.js - <wgw-logo> custom element + Web Animations player for the inline WGW logo.
   Reference prototype (crucible wgw-logo-animation, VAL-1-build). Classic script: no modules,
   no build step beyond build.py embedding the web tracks at the token below.

   Contract (D-7a = challenge.md A-4/A-5):
   - The build emits every wrapper; this player never edits the logo's DOM. Each wrapper carries
     data-ch (a channel name, or two names joined by "+" when the build merged channels whose key
     times and easings are identical) and, unless it only translates, an inline
     transform-origin in its own local user units. Parts are found by data-part.
   - Tracks: {variant, total_ms, easing:{name:[x1,y1,x2,y2]}, parts:{id:{channel:[[t_ms,value,ease],...],
     area?:true}}} in user units (1/10 source px), degrees and ms.
   - WAAPI mapping: one Animation per wrapper; delay = first key time; duration = last - first;
     keyframe offsets from that channel's own keys; per-keyframe easing = cubic-bezier from the
     named table (never linear()); fill 'both'; an area channel s becomes scale(1/s, s) (sy) or
     scale(s, 1/s) (sx) per key, which WAAPI interpolates per component (observation X-1).
     All animations are created in one synchronous loop and given the same startTime.
   - Wrappers are resolved lazily on the first play()/seek() and again after reconnection,
     never in the constructor or connectedCallback (A-5, C-14).
   Triggers (A-8 as revised at the Challenge gate), robustness and #wgw-debug (A-9): see below. */
(function () {
  'use strict';
  if (!window.customElements || window.customElements.get('wgw-logo')) return;

  var TRACKS_WEB = {"variant":"web","total_ms":1980,"easing":{"accel":[0.3,0.0,0.8,0.15],"decel":[0.05,0.7,0.1,1.0],"inQuad":[0.3333333333333333,0.0,0.6666666666666666,0.3333333333333333],"io":[0.45,0.0,0.55,1.0],"lin":[0.0,0.0,1.0,1.0],"outQuad":[0.3333333333333333,0.6666666666666666,0.6666666666666666,1.0]},"parts":{"r1-W":{"ty":[[0,0,"io"],[36,0,"outQuad"],[135,-380,"inQuad"],[234,0,"lin"],[300,0,"lin"]],"sy":[[0,1,"io"],[36,0.95,"io"],[72,1.05,"io"],[135,1,"io"],[210,1.03,"io"],[240,0.94,"io"],[273,1.018,"io"],[300,1,"lin"]],"area":true},"r1-H":{"ty":[[55,0,"io"],[91,0,"outQuad"],[190,-380,"inQuad"],[289,0,"lin"],[355,0,"lin"]],"sy":[[55,1,"io"],[91,0.95,"io"],[127,1.05,"io"],[190,1,"io"],[265,1.03,"io"],[295,0.94,"io"],[328,1.018,"io"],[355,1,"lin"]],"area":true},"r1-E1":{"ty":[[110,0,"io"],[146,0,"outQuad"],[245,-380,"inQuad"],[344,0,"lin"],[410,0,"lin"]],"sy":[[110,1,"io"],[146,0.95,"io"],[182,1.05,"io"],[245,1,"io"],[320,1.03,"io"],[350,0.94,"io"],[383,1.018,"io"],[410,1,"lin"]],"area":true},"r1-E2":{"ty":[[165,0,"io"],[201,0,"outQuad"],[300,-380,"inQuad"],[399,0,"lin"],[465,0,"lin"]],"sy":[[165,1,"io"],[201,0.95,"io"],[237,1.05,"io"],[300,1,"io"],[375,1.03,"io"],[405,0.94,"io"],[438,1.018,"io"],[465,1,"lin"]],"area":true},"r1-L":{"ty":[[220,0,"io"],[256,0,"outQuad"],[355,-380,"inQuad"],[454,0,"lin"],[520,0,"lin"]],"sy":[[220,1,"io"],[256,0.95,"io"],[292,1.05,"io"],[355,1,"io"],[430,1.03,"io"],[460,0.94,"io"],[493,1.018,"io"],[520,1,"lin"]],"area":true},"r1-I":{"ty":[[275,0,"io"],[311,0,"outQuad"],[410,-380,"inQuad"],[509,0,"lin"],[575,0,"lin"]],"sy":[[275,1,"io"],[311,0.95,"io"],[347,1.05,"io"],[410,1,"io"],[485,1.03,"io"],[515,0.94,"io"],[548,1.018,"io"],[575,1,"lin"]],"area":true},"r1-E3":{"ty":[[330,0,"io"],[366,0,"outQuad"],[465,-380,"inQuad"],[564,0,"lin"],[630,0,"lin"]],"sy":[[330,1,"io"],[366,0.95,"io"],[402,1.05,"io"],[465,1,"io"],[540,1.03,"io"],[570,0.94,"io"],[603,1.018,"io"],[630,1,"lin"]],"area":true},"r2-G":{"gtx":[[490,0,"accel"],[630,100,"lin"],[660,100,"decel"],[835,-45.6,"io"],[960,0,"lin"]],"sx":[[630,1,"decel"],[645,0.9,"lin"],[660,0.9,"io"],[720,1.03,"io"],[780,1,"lin"]],"area":true},"r2-O1":{"gtx":[[660,0,"lin"],[730,120,"lin"],[760,120,"decel"],[935,-30.4,"io"],[1060,0,"lin"]],"sx":[[730,1,"decel"],[745,0.95,"lin"],[760,0.95,"io"],[815,1.02,"io"],[865,1,"lin"]],"area":true,"spin":[[630,0,"lin"],[1255,240,"outQuad"],[1880,360,"lin"]]},"r2-O2":{"gtx":[[760,0,"lin"],[830,110,"lin"],[860,110,"decel"],[1035,-30.4,"io"],[1160,0,"lin"]],"sx":[[830,1,"decel"],[845,0.95,"lin"],[860,0.95,"io"],[915,1.02,"io"],[965,1,"lin"]],"area":true,"spin":[[730,0,"lin"],[1355,240,"outQuad"],[1980,360,"lin"]]},"r2-D":{"sx":[[830,1,"decel"],[845,0.92,"io"],[900,1.04,"io"],[950,1,"lin"]],"area":true,"gtx":[[860,0,"decel"],[1010,182.4,"io"],[1202.5,-36.48,"io"],[1367.5,9.12,"io"],[1560,0,"lin"]],"grot":[[860,0,"decel"],[1010,4,"io"],[1202.5,-1.6,"io"],[1367.5,0.6,"io"],[1560,0,"lin"]]},"r2-mk-01":{"wig":[[630,0,"io"],[665.7,3.69,"io"],[737.1,-1.943,"io"],[808.6,1.023,"io"],[880,-0.539,"io"],[951.4,0.284,"io"],[987.1,0,"lin"]],"pop":[[630,1,"decel"],[670,1.064407,"io"],[750,0.9839,"io"],[830,1.0064,"io"],[910,1,"lin"]]},"r2-mk-02":{"wig":[[645,0,"io"],[680.7,-14,"io"],[752.1,7.373,"io"],[823.6,-3.883,"io"],[895,2.045,"io"],[966.4,-1.077,"io"],[1002.1,0,"lin"]],"pop":[[645,1,"decel"],[685,1.247154,"io"],[765,0.9382,"io"],[845,1.0247,"io"],[925,1,"lin"]]},"r2-mk-03":{"wig":[[645,0,"io"],[680.7,11.535,"io"],[752.1,-6.075,"io"],[823.6,3.199,"io"],[895,-1.685,"io"],[966.4,0.887,"io"],[1002.1,0,"lin"]],"pop":[[645,1,"decel"],[685,1.201325,"io"],[765,0.9497,"io"],[845,1.0201,"io"],[925,1,"lin"]]},"r2-mk-04":{"wig":[[660,0,"io"],[695.7,-9.135,"io"],[767.1,4.811,"io"],[838.6,-2.533,"io"],[910,1.334,"io"],[981.4,-0.703,"io"],[1017.1,0,"lin"]],"pop":[[660,1,"decel"],[700,1.159441,"io"],[780,0.9601,"io"],[860,1.0159,"io"],[940,1,"lin"]]},"r2-mk-05":{"wig":[[675,0,"io"],[710.7,13.262,"io"],[782.1,-6.984,"io"],[853.6,3.678,"io"],[925,-1.937,"io"],[996.4,1.02,"io"],[1032.1,0,"lin"]],"pop":[[675,1,"decel"],[715,1.231472,"io"],[795,0.9421,"io"],[875,1.0231,"io"],[955,1,"lin"]]},"r2-mk-06":{"wig":[[690,0,"io"],[725.7,-14,"io"],[797.1,7.373,"io"],[868.6,-3.883,"io"],[940,2.045,"io"],[1011.4,-1.077,"io"],[1047.1,0,"lin"]],"pop":[[690,1,"decel"],[730,1.3,"io"],[810,0.925,"io"],[890,1.03,"io"],[970,1,"lin"]]},"r2-mk-07":{"wig":[[705,0,"io"],[740.7,14,"io"],[812.1,-7.373,"io"],[883.6,3.883,"io"],[955,-2.045,"io"],[1026.4,1.077,"io"],[1062.1,0,"lin"]],"pop":[[705,1,"decel"],[745,1.310204,"io"],[825,0.9224,"io"],[905,1.031,"io"],[985,1,"lin"]]},"r2-mk-08":{"wig":[[760,0,"io"],[795.7,-13.433,"io"],[867.1,7.074,"io"],[938.6,-3.725,"io"],[1010,1.962,"io"],[1081.4,-1.033,"io"],[1117.1,0,"lin"]],"pop":[[760,1,"decel"],[800,1.234447,"io"],[880,0.9414,"io"],[960,1.0234,"io"],[1040,1,"lin"]]},"r2-mk-09":{"wig":[[760,0,"io"],[795.7,14,"io"],[867.1,-7.373,"io"],[938.6,3.883,"io"],[1010,-2.045,"io"],[1081.4,1.077,"io"],[1117.1,0,"lin"]],"pop":[[760,1,"decel"],[800,1.275529,"io"],[880,0.9311,"io"],[960,1.0276,"io"],[1040,1,"lin"]]},"r2-mk-10":{"wig":[[760,0,"io"],[795.7,-7.237,"io"],[867.1,3.811,"io"],[938.6,-2.007,"io"],[1010,1.057,"io"],[1081.4,-0.557,"io"],[1117.1,0,"lin"]],"pop":[[760,1,"decel"],[800,1.126316,"io"],[880,0.9684,"io"],[960,1.0126,"io"],[1040,1,"lin"]]},"r2-mk-11":{"wig":[[760,0,"io"],[795.7,9.364,"io"],[867.1,-4.932,"io"],[938.6,2.597,"io"],[1010,-1.368,"io"],[1081.4,0.72,"io"],[1117.1,0,"lin"]],"pop":[[760,1,"decel"],[800,1.163441,"io"],[880,0.9591,"io"],[960,1.0163,"io"],[1040,1,"lin"]]},"r2-mk-12":{"wig":[[845,0,"io"],[880.7,-3.42,"io"],[952.1,1.801,"io"],[1023.6,-0.948,"io"],[1095,0.499,"io"],[1166.4,-0.263,"io"],[1202.1,0,"lin"]],"pop":[[845,1,"decel"],[885,1.059686,"io"],[965,0.9851,"io"],[1045,1.006,"io"],[1125,1,"lin"]]},"r2-mk-13":{"wig":[[845,0,"io"],[880.7,9.314,"io"],[952.1,-4.905,"io"],[1023.6,2.583,"io"],[1095,-1.36,"io"],[1166.4,0.716,"io"],[1202.1,0,"lin"]],"pop":[[845,1,"decel"],[885,1.162567,"io"],[965,0.9594,"io"],[1045,1.0163,"io"],[1125,1,"lin"]]},"r2-mk-14":{"wig":[[875,0,"io"],[910.7,-14,"io"],[982.1,7.373,"io"],[1053.6,-3.883,"io"],[1125,2.045,"io"],[1196.4,-1.077,"io"],[1232.1,0,"lin"]],"pop":[[875,1,"decel"],[915,1.316667,"io"],[995,0.9208,"io"],[1075,1.0317,"io"],[1155,1,"lin"]]},"r2-mk-15":{"wig":[[890,0,"io"],[925.7,11.769,"io"],[997.1,-6.198,"io"],[1068.6,3.264,"io"],[1140,-1.719,"io"],[1211.4,0.905,"io"],[1247.1,0,"lin"]],"pop":[[890,1,"decel"],[930,1.205405,"io"],[1010,0.9486,"io"],[1090,1.0205,"io"],[1170,1,"lin"]]},"r2-mk-16":{"wig":[[905,0,"io"],[940.7,-14,"io"],[1012.1,7.373,"io"],[1083.6,-3.883,"io"],[1155,2.045,"io"],[1226.4,-1.077,"io"],[1262.1,0,"lin"]],"pop":[[905,1,"decel"],[945,1.285,"io"],[1025,0.9287,"io"],[1105,1.0285,"io"],[1185,1,"lin"]]},"r2-mk-17":{"wig":[[920,0,"io"],[955.7,14,"io"],[1027.1,-7.373,"io"],[1098.6,3.883,"io"],[1170,-2.045,"io"],[1241.4,1.077,"io"],[1277.1,0,"lin"]],"pop":[[920,1,"decel"],[960,1.250549,"io"],[1040,0.9374,"io"],[1120,1.0251,"io"],[1200,1,"lin"]]},"r2-mk-18":{"wig":[[935,0,"io"],[970.7,-4.807,"io"],[1042.1,2.532,"io"],[1113.6,-1.333,"io"],[1185,0.702,"io"],[1256.4,-0.37,"io"],[1292.1,0,"lin"]],"pop":[[935,1,"decel"],[975,1.083901,"io"],[1055,0.979,"io"],[1135,1.0084,"io"],[1215,1,"lin"]]},"r3-W":{"ty":[[890,0,"io"],[926,0,"outQuad"],[1025,-228,"inQuad"],[1124,0,"lin"],[1190,0,"lin"]],"sy":[[890,1,"io"],[926,0.95,"io"],[962,1.03,"io"],[1025,1,"io"],[1100,1.02,"io"],[1130,0.95,"io"],[1163,1.015,"io"],[1190,1,"lin"]],"area":true},"r3-H":{"ty":[[945,0,"io"],[981,0,"outQuad"],[1080,-228,"inQuad"],[1179,0,"lin"],[1245,0,"lin"]],"sy":[[945,1,"io"],[981,0.95,"io"],[1017,1.03,"io"],[1080,1,"io"],[1155,1.02,"io"],[1185,0.95,"io"],[1218,1.015,"io"],[1245,1,"lin"]],"area":true},"r3-E1":{"ty":[[1000,0,"io"],[1036,0,"outQuad"],[1135,-228,"inQuad"],[1234,0,"lin"],[1300,0,"lin"]],"sy":[[1000,1,"io"],[1036,0.95,"io"],[1072,1.03,"io"],[1135,1,"io"],[1210,1.02,"io"],[1240,0.95,"io"],[1273,1.015,"io"],[1300,1,"lin"]],"area":true},"r3-E2":{"ty":[[1055,0,"io"],[1091,0,"outQuad"],[1190,-228,"inQuad"],[1289,0,"lin"],[1355,0,"lin"]],"sy":[[1055,1,"io"],[1091,0.95,"io"],[1127,1.03,"io"],[1190,1,"io"],[1265,1.02,"io"],[1295,0.95,"io"],[1328,1.015,"io"],[1355,1,"lin"]],"area":true},"r3-L":{"ty":[[1110,0,"io"],[1146,0,"outQuad"],[1245,-228,"inQuad"],[1344,0,"lin"],[1410,0,"lin"]],"sy":[[1110,1,"io"],[1146,0.95,"io"],[1182,1.03,"io"],[1245,1,"io"],[1320,1.02,"io"],[1350,0.95,"io"],[1383,1.015,"io"],[1410,1,"lin"]],"area":true},"r3-S":{"ty":[[1165,0,"io"],[1201,0,"outQuad"],[1300,-228,"inQuad"],[1399,0,"lin"],[1465,0,"lin"]],"sy":[[1165,1,"io"],[1201,0.95,"io"],[1237,1.03,"io"],[1300,1,"io"],[1375,1.02,"io"],[1405,0.95,"io"],[1438,1.015,"io"],[1465,1,"lin"]],"area":true}}};   // build.py replaces this token with the web tracks

  var COOLDOWN_MS = 3000;      // one shared cooldown after each finish (A-8), kept in sessionStorage
  var ZONE_DWELL_MS = 400;     // header + side menus: dwell started only by real pointer movement
  var LOGO_DWELL_MS = 200;     // logo hover
  var SCROLL_QUIET_MS = 500;   // pointer entries during a scroll, or within 500 ms after it, are ignored
  var KEY_LAST_END = 'wgw-logo:last-end';   // Date.now() of the last finish (shared by every trigger)
  var KEY_VISITED = 'wgw-logo:visited';     // set on the first page view of a visit (per tab)

  var hasWAAPI = typeof Element !== 'undefined' && typeof Element.prototype.animate === 'function';
  var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var DEBUG = /(^#|[#&])wgw-debug(&|=|$)/.test(location.hash || '');

  // ---- sessionStorage, with an in-memory fallback for private windows / blocked storage ----
  var mem = {};
  function sget(k) {
    try { var v = window.sessionStorage.getItem(k); if (v !== null) return v; } catch (e) { /* blocked */ }
    return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null;
  }
  function sset(k, v) {
    mem[k] = String(v);
    try { window.sessionStorage.setItem(k, String(v)); } catch (e) { /* blocked */ }
  }

  // ---- scroll tracking, shared by every instance (C-21: Dawn's scroll-up reveal fires pointerenter) ----
  var lastScroll = -Infinity;
  var live = [];
  window.addEventListener('scroll', function () {
    lastScroll = performance.now();
    for (var i = 0; i < live.length; i++) live[i]._onScroll();
  }, { passive: true, capture: true });
  function scrolling() { return performance.now() - lastScroll < SCROLL_QUIET_MS; }
  function hoverPointer(e) { return e.pointerType === 'mouse' || e.pointerType === 'pen'; }
  function moved(e) { return !!(e.movementX || e.movementY); }   // synthetic post-scroll moves have 0

  function whenLoadedAndVisible(fn) {
    function vis() {
      if (document.visibilityState === 'visible') { fn(); return; }
      document.addEventListener('visibilitychange', function h() {
        if (document.visibilityState !== 'visible') return;
        document.removeEventListener('visibilitychange', h); fn();
      });
    }
    if (document.readyState === 'complete') vis();
    else window.addEventListener('load', vis, { once: true });
  }

  // ---- tracks -> keyframes (A-5 mapping) ----
  var easeCache = {};
  function easing(tracks, name) {
    var b = tracks.easing[name];
    if (!b) throw new Error('unknown easing ' + name);
    var key = tracks.variant + ':' + name + ':' + b.join(',');   /* VAL-2 FIX F3: keyed by the values */
    if (!easeCache[key]) {
      easeCache[key] = 'cubic-bezier(' + b.join(',') + ')';
    }
    return easeCache[key];
  }
  function fn(ch, p, v) {
    switch (ch) {
      case 'tx': case 'gtx': return 'translate(' + v + 'px,0px)';
      case 'ty': return 'translate(0px,' + v + 'px)';
      case 'rot': case 'grot': case 'wig': case 'spin': return 'rotate(' + v + 'deg)';
      case 'sx': return p.area ? 'scale(' + v + ',' + (1 / v) + ')' : 'scale(' + v + ',1)';
      case 'sy': return p.area ? 'scale(' + (1 / v) + ',' + v + ')' : 'scale(1,' + v + ')';
      case 'pop': return 'scale(' + v + ')';
    }
    throw new Error('unknown channel ' + ch);
  }
  // One Animation spec for one wrapper. Merged wrappers ("gtx+grot") share key times and easings.
  function spec(tracks, part, chName) {
    var p = tracks.parts[part];
    if (!p) return null;
    var chs = chName.split('+');
    var keys = p[chs[0]];
    if (!keys) return null;
    for (var j = 1; j < chs.length; j++) {
      var other = p[chs[j]];
      if (!other || other.length !== keys.length) throw new Error('merged channels differ: ' + part + ' ' + chName);
    }
    var t0 = keys[0][0], dur = keys[keys.length - 1][0] - t0;
    var frames = [];
    for (var i = 0; i < keys.length; i++) {
      var tf = [];
      for (j = 0; j < chs.length; j++) tf.push(fn(chs[j], p, p[chs[j]][i][1]));
      var f = { offset: dur > 0 ? (keys[i][0] - t0) / dur : 0, transform: tf.join(' ') };
      if (i < keys.length - 1) f.easing = easing(tracks, keys[i][2]);
      frames.push(f);
    }
    return { frames: frames, timing: { delay: t0, duration: dur, fill: 'both', easing: 'linear', iterations: 1 } };
  }

  // 2x3 affine helpers on plain arrays [a,b,c,d,e,f] (SVG order), so the self-test does not depend
  // on DOMMatrix/SVGMatrix interop, which differs between engines.
  function arr6(m) { return [m.a, m.b, m.c, m.d, m.e, m.f]; }
  function mul6(p, q) {
    return [p[0] * q[0] + p[2] * q[1], p[1] * q[0] + p[3] * q[1], p[0] * q[2] + p[2] * q[3],
      p[1] * q[2] + p[3] * q[3], p[0] * q[4] + p[2] * q[5] + p[4], p[1] * q[4] + p[3] * q[5] + p[5]];
  }
  function inv6(m) {
    var det = m[0] * m[3] - m[1] * m[2];
    return [m[3] / det, -m[1] / det, -m[2] / det, m[0] / det,
      (m[2] * m[5] - m[3] * m[4]) / det, (m[1] * m[4] - m[0] * m[5]) / det];
  }

  var debugBox = null;

  class WgwLogo extends HTMLElement {
    static get observedAttributes() { return ['variant']; }

    constructor() {
      super();
      this._anims = null;       // Animation[] currently applied (playing, paused or finished)
      this._wr = null;          // resolved wrappers [{el, part, ch}], lazily
      this._busy = false;       // playing
      this._gen = 0;            // invalidates stale finish handlers
      this._zone = null; this._link = null; this._opener = null;
      this._zoneOk = false; this._zoneTimer = 0; this._logoOk = false; this._logoTimer = 0;
      this.playCount = 0;
      this.lastError = null;
      this.lastSource = null;
    }

    // ---------------- lifecycle: bind listeners only; never touch the logo's DOM here ----------------
    connectedCallback() {
      var self = this;
      this._wr = null;                                   // re-resolve wrappers after (re)connection
      live.push(this);
      this._zoneSeen = false; this._logoSeen = false;   /* VAL-2 FIX F2 */
      var sel = this.getAttribute('data-trigger');
      this._zone = null;
      if (sel) { try { this._zone = this.closest(sel) || document.querySelector(sel); } catch (e) { this._err(e); } }
      var osel = this.getAttribute('data-open-trigger');
      this._opener = null;
      if (osel) { try { this._opener = document.querySelector(osel); } catch (e) { this._err(e); } }
      this._link = this.closest('a');

      this._h = {
        zoneEnter: function (e) {
          if (!hoverPointer(e)) return;
          self._zoneSeen = true;   /* VAL-2 FIX F2 */
          self._zoneOk = !scrolling();        // an entry during/just after a scroll never arms
          self._clearZone();
        },
        zoneMove: function (e) {
          if (!self._zoneSeen && hoverPointer(e)) { self._zoneSeen = true; self._zoneOk = !scrolling(); }   /* VAL-2 FIX F2: entry missed before binding */
          if (!self._zoneOk || self._zoneTimer || !hoverPointer(e) || !moved(e) || scrolling()) return;
          self._zoneTimer = setTimeout(function () {
            self._zoneTimer = 0;
            if (!self._zoneOk) return;
            self._zoneOk = false;               // one play per entry: re-arms when the pointer leaves
            if (!self._trigger('header') && self._refusedByCooldown) self._zoneOk = true;   /* VAL-2 PATCH (rearm): a cooldown refusal does not consume the entry */
          }, ZONE_DWELL_MS);
        },
        zoneLeave: function () { self._zoneSeen = true; self._zoneOk = false; self._clearZone(); },
        logoEnter: function (e) {
          if (!hoverPointer(e)) return;
          self._logoSeen = true;   /* VAL-2 FIX F2 */
          self._logoOk = !scrolling();
          self._clearLogo();
        },
        logoMove: function (e) {
          if (!self._logoSeen && hoverPointer(e)) { self._logoSeen = true; self._logoOk = !scrolling(); }   /* VAL-2 FIX F2 */
          if (!self._logoOk || self._logoTimer || !hoverPointer(e) || !moved(e) || scrolling()) return;
          self._logoTimer = setTimeout(function () {
            self._logoTimer = 0;
            if (!self._logoOk) return;
            self._logoOk = false;
            if (!self._trigger('logo') && self._refusedByCooldown) self._logoOk = true;   /* VAL-2 PATCH (rearm) */
          }, LOGO_DWELL_MS);
        },
        logoLeave: function () { self._logoSeen = true; self._logoOk = false; self._clearLogo(); },
        focus: function () {
          var l = self._link;
          var fv = false;
          try { fv = l.matches(':focus-visible'); } catch (e) { fv = false; }
          if (fv) self._trigger('focus');
        },
        toggle: function (e) { if (e.target && e.target.open) self._trigger('drawer'); },
        reduce: function () { if (reduceMQ.matches && self._anims) self._anims.forEach(function (a) { try { a.finish(); } catch (x) { } }); }
      };
      if (this._zone) {
        this._zone.addEventListener('pointerenter', this._h.zoneEnter);
        this._zone.addEventListener('pointermove', this._h.zoneMove);
        this._zone.addEventListener('pointerleave', this._h.zoneLeave);
      }
      this.addEventListener('pointerenter', this._h.logoEnter);
      this.addEventListener('pointermove', this._h.logoMove);
      this.addEventListener('pointerleave', this._h.logoLeave);
      if (this._link) this._link.addEventListener('focus', this._h.focus);
      if (this._opener) this._opener.addEventListener('toggle', this._h.toggle);
      if (reduceMQ && reduceMQ.addEventListener) reduceMQ.addEventListener('change', this._h.reduce);

      if (!this._autoplayQueued) {                       // initial page view (A-8)
        this._autoplayQueued = true;
        var mode = this.getAttribute('data-autoplay') || 'visit';
        if (mode === 'visit' || mode === 'page') {
          whenLoadedAndVisible(function () {
            if (!self.isConnected) return;
            if (mode === 'visit') {
              if (sget(KEY_VISITED)) return;
              sset(KEY_VISITED, '1');
            }
            self._trigger('autoplay');
          });
        }
      }
      if (DEBUG) whenLoadedAndVisible(function () { self._debug(); });
    }

    disconnectedCallback() {
      var i = live.indexOf(this);
      if (i >= 0) live.splice(i, 1);
      if (this._h) {
        if (this._zone) {
          this._zone.removeEventListener('pointerenter', this._h.zoneEnter);
          this._zone.removeEventListener('pointermove', this._h.zoneMove);
          this._zone.removeEventListener('pointerleave', this._h.zoneLeave);
        }
        this.removeEventListener('pointerenter', this._h.logoEnter);
        this.removeEventListener('pointermove', this._h.logoMove);
        this.removeEventListener('pointerleave', this._h.logoLeave);
        if (this._link) this._link.removeEventListener('focus', this._h.focus);
        if (this._opener) this._opener.removeEventListener('toggle', this._h.toggle);
        if (reduceMQ && reduceMQ.removeEventListener) reduceMQ.removeEventListener('change', this._h.reduce);
      }
      this._clearZone(); this._clearLogo();
      this._cancel();
      this._wr = null;
      this._busy = false;
    }

    attributeChangedCallback(name, oldV, newV) {
      if (name === 'variant' && oldV !== newV) { this._cancel(); }
    }

    // ---------------- public API ----------------
    get variant() { return this.getAttribute('variant') === 'social' ? 'social' : 'web'; }
    get tracks() { return this.variant === 'social' ? (window.WGW_LOGO_TRACKS_SOCIAL || null) : TRACKS_WEB; }
    get duration() { var t = this.tracks; return t ? t.total_ms : 0; }
    get playing() { return this._busy; }

    // Plays the whole cycle once. Programmatic play skips the cooldown but never runs under reduced
    // motion, in a hidden tab, or while already playing. Returns true if it started.
    play() { return this._trigger('api', true); }

    // Freezes the logo at ms. Works under reduced motion too, because capture and tests call it
    // explicitly. Returns true on success. Outside the motion window (before the first key or at/after
    // the last key every channel is at rest) the animations are DETACHED, not held: Chromium rasterises
    // the whole inline SVG differently while any transform animation is attached, even one paused at
    // identity (VAL-1-build measured 4,967 changed px at 360 px), so only a detached logo is
    // pixel-identical to the static SVG.
    seek(ms) {
      var w = this._window();
      if (w && (ms <= w[0] || ms >= w[1])) {
        this._cancel();
        this._busy = false;
        this.removeAttribute('data-playing');
        return true;
      }
      var anims = (this._anims && this._anims.length && this._fresh()) ? this._anims : this._build();
      if (!anims) return false;
      this._gen++;
      for (var i = 0; i < anims.length; i++) { anims[i].pause(); anims[i].currentTime = ms; }
      this._busy = false;
      this.removeAttribute('data-playing');
      return true;
    }

    // ---------------- internals ----------------
    _onScroll() { this._clearZone(); this._clearLogo(); }   // a scroll cancels any pending dwell
    _clearZone() { if (this._zoneTimer) { clearTimeout(this._zoneTimer); this._zoneTimer = 0; } }
    _clearLogo() { if (this._logoTimer) { clearTimeout(this._logoTimer); this._logoTimer = 0; } }

    _err(e) {
      this.lastError = (e && (e.name ? e.name + ': ' : '') + (e.message || e)) || String(e);
      this.setAttribute('data-error', this.lastError);
      if (debugBox) debugBox.refresh();
    }

    // Rules shared by every trigger (A-8): never under reduced motion, never in a hidden tab,
    // never restart while playing, and one shared 3 s cooldown after each finish (sessionStorage).
    _trigger(source, skipCooldown) {
      this._refusedByCooldown = false;   /* VAL-2 PATCH (rearm) */
      if (!hasWAAPI) { this._err(new Error('Element.prototype.animate is missing; static logo')); return false; }
      if (reduceMQ && reduceMQ.matches) return false;
      if (document.visibilityState === 'hidden') return false;
      if (this._busy) return false;
      if (!skipCooldown) {
        var last = +(sget(KEY_LAST_END) || 0), now = Date.now();
        if (now >= last && now - last < COOLDOWN_MS) { this._refusedByCooldown = true; return false; }   /* VAL-2 PATCH (rearm) */
      }
      return this._start(source);
    }

    _fresh() {
      var w = this._wr;
      return !!(w && w.length && w[0].el.isConnected && this.contains(w[0].el));
    }

    // [first key time, last key time] over every channel: outside it the whole logo is at rest.
    _window() {
      var t = this.tracks;
      if (!t) return null;
      if (t.__win) return t.__win;
      var lo = Infinity, hi = -Infinity;
      for (var id in t.parts) {
        var p = t.parts[id];
        for (var ch in p) {
          var k = p[ch];
          if (!k || !k.length || typeof k === 'boolean') continue;
          if (k[0][0] < lo) lo = k[0][0];
          if (k[k.length - 1][0] > hi) hi = k[k.length - 1][0];
        }
      }
      try { Object.defineProperty(t, '__win', { value: [lo, hi] }); } catch (e) { /* frozen tracks */ }
      return [lo, hi];
    }

    _resolve() {
      if (this._fresh()) return this._wr;
      var nodes = this.querySelectorAll('[data-ch]');
      var out = [];
      for (var i = 0; i < nodes.length; i++) {
        var pe = nodes[i].closest('[data-part]');
        out.push({ el: nodes[i], ch: nodes[i].getAttribute('data-ch'), part: pe ? pe.getAttribute('data-part') : null });
      }
      this._wr = out;
      return out;
    }

    _cancel() {
      if (this._anims) this._anims.forEach(function (a) { try { a.cancel(); } catch (e) { } });
      this._anims = null;
      this._gen++;
    }

    // All-or-nothing build (A-9): any error cancels whatever was created and keeps the static logo.
    _build() {
      if (!hasWAAPI) { this._err(new Error('Element.prototype.animate is missing; static logo')); return null; }
      var tracks = this.tracks;
      if (!tracks) { this._err(new Error('no tracks for variant ' + this.variant)); return null; }
      this._cancel();
      var created = [];
      try {
        var wr = this._resolve();
        for (var i = 0; i < wr.length; i++) {
          var s = spec(tracks, wr[i].part, wr[i].ch);
          if (s) created.push(wr[i].el.animate(s.frames, s.timing));
        }
        if (!created.length) throw new Error('no wrappers matched the tracks');
      } catch (e) {
        for (var k = 0; k < created.length; k++) { try { created[k].cancel(); } catch (x) { } }
        this._anims = null;
        this._busy = false;
        this.removeAttribute('data-playing');
        this._err(e);
        return null;
      }
      this._anims = created;
      return created;
    }

    _start(source) {
      var anims = this._build();
      if (!anims) return false;
      var self = this, gen = ++this._gen;
      /* VAL-2 FIX F1: no explicit startTime (stale timeline in Firefox); animations created in this one
         synchronous loop are started together by the engine at the next frame. */
      this._busy = true;
      this.playCount++;
      this.lastSource = source;
      this.setAttribute('data-playing', source);
      this.dispatchEvent(new CustomEvent('wgwplay', { bubbles: true, detail: { source: source } }));
      if (debugBox) debugBox.refresh();
      Promise.all(anims.map(function (a) { return a.finished; })).then(function () {
        if (gen !== self._gen) return;
        self._cancel();                    // detach at rest: the static raster path (see seek())
        self._busy = false;
        self.removeAttribute('data-playing');
        sset(KEY_LAST_END, Date.now());
        self.dispatchEvent(new CustomEvent('wgwfinish', { bubbles: true, detail: { source: source } }));
      }, function () {
        if (gen !== self._gen) return;
        self._busy = false;
        self.removeAttribute('data-playing');
      });
      return true;
    }

    // ---------------- #wgw-debug (A-9) ----------------
    _debug() {
      if (debugBox) return;                               // one overlay per page, bound to the first logo
      var self = this;
      var box = document.createElement('div');
      box.id = 'wgw-debug-box';
      /* ORCHESTRATOR FIX: centred, not bottom-right. Shopify's preview bar is a top-layer popover at the
         bottom of the viewport that covers anything placed there, whatever its z-index. */
      box.setAttribute('style', 'position:fixed;left:50%;top:45%;transform:translate(-50%,-50%);z-index:2147483647;' +
        'width:min(340px,calc(100vw - 16px));box-sizing:border-box;' +
        'font:12px/1.35 system-ui,sans-serif;background:#fff;color:#000;border:2px solid #000;padding:8px;' +
        'white-space:pre-wrap;word-break:break-word');
      var info = document.createElement('div');
      var bPlay = document.createElement('button'); bPlay.type = 'button'; bPlay.textContent = 'play now';
      var bTest = document.createElement('button'); bTest.type = 'button'; bTest.textContent = 'self-test';
      var bHide = document.createElement('button'); bHide.type = 'button'; bHide.textContent = 'hide';
      bHide.addEventListener('click', function () { box.style.display = 'none'; });
      var res = document.createElement('div'); res.id = 'wgw-debug-result';
      box.appendChild(info); box.appendChild(bPlay); box.appendChild(bTest); box.appendChild(bHide); box.appendChild(res);
      document.body.appendChild(box);
      var lin = false;
      try { lin = !!(window.CSS && CSS.supports('animation-timing-function', 'linear(0, 1)')); } catch (e) { lin = false; }
      debugBox = {
        refresh: function () {
          info.textContent = 'UA: ' + navigator.userAgent +
            '\nWAAPI: ' + hasWAAPI + '   linear(): ' + lin +
            '\nreduced motion: ' + (reduceMQ ? reduceMQ.matches : 'n/a') +
            '\nvariant: ' + self.variant + '   plays: ' + self.playCount + (self.lastSource ? ' (last: ' + self.lastSource + ')' : '') +
            '\nlast error: ' + (self.lastError || 'none') + '\n';
        }
      };
      debugBox.refresh();
      bPlay.addEventListener('click', function () { self.play(); debugBox.refresh(); });
      bTest.addEventListener('click', function () { self._selfTest(res); });
      /* ORCHESTRATOR FIX (V-41): run the self-test only from its button, so it cannot cut short the first-visit autoplay. */
      res.textContent = 'self-test: press the button';
    }

    // Fetches the reference CTMs (only in debug mode), seeks to each event time and compares every
    // part's CTM relative to the SVG root with the oracle's: max corner error in source px.
    _selfTest(out) {
      var self = this, url = this.getAttribute('data-ref');
      if (!url) { out.textContent = 'self-test: no data-ref'; return; }
      out.textContent = 'self-test: fetching ' + url + ' ...';
      fetch(url, { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (all) {
        var ref = all[self.variant];
        if (!ref) throw new Error('reference has no variant ' + self.variant);
        var svg = self.querySelector('svg');
        var worst = 0, where = '';
        for (var i = 0; i < ref.times.length; i++) {
          var t = ref.times[i];
          if (!self.seek(t)) throw new Error('seek failed: ' + self.lastError);
          var root = inv6(arr6(svg.getScreenCTM()));
          var mats = ref.frames[i];
          for (var id in mats) {
            var el = self._partPath(svg, id);
            if (!el) throw new Error('part not found: ' + id);
            var m = mul6(root, arr6(el.getScreenCTM()));      // part CTM relative to the SVG root
            if (id.indexOf('/spokes') > 0) m = mul6(m, inv6(ref.wheel_M[id.split('/')[0]]));
            var e = mats[id], cs = ref.corners[id];
            for (var c = 0; c < cs.length; c++) {
              var x = cs[c][0], y = cs[c][1];
              var dx = (m[0] * x + m[2] * y + m[4]) - (e[0] * x + e[2] * y + e[4]);
              var dy = (m[1] * x + m[3] * y + m[5]) - (e[1] * x + e[3] * y + e[5]);
              var err = Math.sqrt(dx * dx + dy * dy) / ref.units_per_source_px;
              if (err > worst) { worst = err; where = id + ' @' + t + 'ms'; }
            }
          }
        }
        self.seek(1e9);                                   // back to rest
        var pass = worst <= ref.tolerance_px;
        out.textContent = 'self-test ' + (pass ? 'PASS' : 'FAIL') + ': max error ' + worst.toFixed(3) +
          ' source px (' + where + ') over ' + ref.times.length + ' event times, tolerance ' + ref.tolerance_px;
        self.setAttribute('data-selftest', (pass ? 'PASS ' : 'FAIL ') + worst.toFixed(4));
      }).catch(function (e) {
        out.textContent = 'self-test ERROR: ' + (e && e.message || e);
        self.setAttribute('data-selftest', 'ERROR ' + (e && e.message || e));
      });
    }

    // A part's own path: the first path inside its data-part element (owners' local wrappers come
    // before their carried marks); "<wheel>/spokes" is the path inside that wheel's spin wrapper.
    _partPath(svg, id) {
      var spokes = id.indexOf('/spokes') > 0;
      var part = svg.querySelector('[data-part="' + id.split('/')[0] + '"]');
      if (!part) return null;
      return spokes ? part.querySelector('[data-ch="spin"] path') : part.querySelector('path');
    }
  }

  window.customElements.define('wgw-logo', WgwLogo);
})();
